var map = {
	"./addeds.png": "15d3",
	"./drincs-icon.png": "21b8",
	"./free_menu-icon.png": "36df",
	"./pasta-icon.png": "c04b",
	"./pizza-icon.png": "14c1",
	"./sushi-icon.png": "91bd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7b79";